import BaseMapper from '../../BaseMapper';

const StaticContentMapper = (data, context) => {
    return data;
};

export default StaticContentMapper;
